import styled from 'styled-components';
import { color } from 'styles/pallete';

export const container = styled.div`
	width: 100%;
	min-width: 400px;
	display: flex;
	flex-direction: column;
	gap: 1.5rem;
	align-items: flex-start;
	justify-content: center;
`;
export const listLinks = styled.div`
	width: 100%;
	min-width: 400px;
	height: 30vh;
	max-height: 400px;
	overflow: auto;
	display: flex;
	flex-direction: column;
	gap: 1.5rem;
	align-items: flex-start;
	justify-content: flex-start;

	@media (max-width: 1000px) {
		min-width: 100%;
	}
`;

export const link = styled.div`
	position: relative;
	width: 99%;
	border: 1px solid ${color.interface.lightGray2};
	border-radius: 5px;
	padding: 1rem;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 1rem;

	> img {
		width: 80px;
		height: 80px;
		border-radius: 5px;
		object-fit: contain;
		background-color: ${color.interface.lightGray3};
	}
`;

export const content = styled.div`
	width: 100%;
	display: flex;
	align-items: flex-start;
	justify-content: center;
	flex-direction: column;
	gap: 0.2rem;

	p,
	b {
		font-size: 1.3rem;
		color: ${color.interface.darkgray};
	}
`;

export const contentColor = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: flex-start;
	flex-direction: row;
	gap: 0.5rem;

	p,
	b {
		font-size: 1.3rem;
		color: ${color.interface.darkgray};
	}
`;

export const ballColor = styled.p<{ $color: string }>`
	min-width: 10px;
	width: 10px;
	min-height: 10px;
	height: 10px;
	border-radius: 50%;
	background-color: ${(props) => props.$color};
`;

export const actions = styled.div`
	position: absolute;
	top: 1rem;
	right: 1rem;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: row;
	gap: 1rem;

	> svg {
		cursor: pointer;
		font-size: 2.2rem;
	}
`;

export const noBanner = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	gap: 1.5rem;
	align-items: center;
	justify-content: center;

	> p {
		color: ${color.interface.lightGray};
		font-weight: 900;
		font-size: 1.5rem;
	}
`;
